import { motion } from "framer-motion";
import { SearchCheck, Hammer, BadgeCheck } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: SearchCheck,
    title: "Diagnóstico",
    text: "Envíanos fotos por el formulario o WhatsApp. Un técnico valora la falla el mismo día.",
  },
  {
    num: "02",
    icon: Hammer,
    title: "Reparación",
    text: "Desmontaje, refacciones y reconstrucción en taller con materiales de especificación original.",
  },
  {
    num: "03",
    icon: BadgeCheck,
    title: "Entrega",
    text: "Instalación, pruebas de recorrido en máquina y garantía por escrito del trabajo realizado.",
  },
];

export default function RepairProcess() {
  return (
    <section
      data-testid="repair-process-section"
      className="gf-section bg-[#0A1B35] relative overflow-hidden"
    >
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#00B4D8]/50 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#00B4D8]" />
            <span className="gf-overline">Cómo trabajamos</span>
          </div>
          <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
            De la falla a la producción{" "}
            <span className="text-[#00B4D8]">en 3 pasos.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.num}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.15, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`repair-step-${s.num}`}
                className="bg-[#0A1B35] p-8 lg:p-10 group hover:bg-[#0d2145] transition-colors duration-500"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono-accent text-[11px] tracking-[0.3em] text-[#00B4D8]">
                    PASO {s.num}
                  </span>
                  <div className="w-11 h-11 border border-white/15 flex items-center justify-center group-hover:border-[#00B4D8] transition-colors duration-500">
                    <Icon size={18} className="text-[#00B4D8]" />
                  </div>
                </div>
                <h3 className="font-display font-bold text-white text-xl tracking-tight mb-3">
                  {s.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed">{s.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
